import { tv } from 'tailwind-variants';

const colors = [
  {
    color: 'primary',
    default: 'bg-primary',
    toned: 'bg-primary/10 text-primary',
    outlined: 'border-primary text-primary'
  },
  {
    color: 'secondary',
    default: 'bg-secondary',
    toned: 'bg-secondary/10 text-secondary',
    outlined: 'border-secondary text-secondary'
  },
  {
    color: 'tertiary',
    default: 'bg-tertiary',
    toned: 'bg-tertiary/10 text-tertiary',
    outlined: 'border-tertiary text-tertiary'
  },
  {
    color: 'success',
    default: 'bg-success',
    toned: 'bg-success-surface text-success',
    outlined: 'border-success text-success'
  },
  {
    color: 'info',
    default: 'bg-info',
    toned: 'bg-info/10 text-info',
    outlined: 'border-info text-info'
  },
  {
    color: 'neutral',
    default: 'bg-neutral',
    toned: 'bg-neutral/10 text-neutral',
    outlined: 'border-neutral text-neutral'
  },
  {
    color: 'good',
    default: 'bg-good',
    toned: 'bg-good/10 text-good',
    outlined: 'border-good text-good'
  },
  {
    color: 'error',
    default: 'bg-error',
    toned: 'bg-error/10 text-error',
    outlined: 'border-error text-error'
  },
  {
    color: 'warning',
    default: 'bg-warning',
    toned: 'bg-warning-surface text-warning',
    outlined: 'border-warning text-warning'
  },
  {
    color: 'black',
    default: 'bg-black',
    toned: 'bg-black/10 text-black',
    outlined: 'border-black text-black'
  }
];

export const chipStyle = tv({
  slots: {
    base: [
      'group relative inline-flex h-8 items-center justify-center rounded-full px-3 text-sm font-medium',
      'focus-visible:outline-none data-[disabled]:cursor-not-allowed'
    ],
    prependIcon: 'mr-2 size-4',
    appendIcon: 'ml-2 size-4',
    overlay: [
      'absolute inset-0 overflow-hidden bg-fixed opacity-0 transition',
      'duration-300 ease-in-out rounded-[inherit] bg-current'
    ],
    ripple: 'bg-current'
  },
  variants: {
    color: {
      primary: 'bg-primary',
      secondary: 'bg-secondary',
      tertiary: 'bg-tertiary',
      black: 'bg-black',
      success: 'bg-success',
      good: 'bg-good',
      neutral: 'bg-neutral',
      info: 'bg-info',
      error: 'bg-error',
      warning: 'bg-warning'
    },
    size: {
      xs: {
        base: 'h-5 px-2 text-2xs',
        prependIcon: 'size-3',
        appendIcon: 'size-3'
      },
      sm: {
        base: 'h-6 px-2.5 text-xs',
        prependIcon: 'mr-1 size-3.5',
        appendIcon: 'ml-1 size-3.5'
      },
      md: {
        base: 'h-8 px-3 text-sm',
        prependIcon: 'mr-2 size-4',
        appendIcon: 'ml-2 size-4'
      }
    },
    variant: {
      default: {
        base: 'shadow-md data-[disabled]:bg-black/10 data-[disabled]:text-black/25 text-white',
        overlay: 'bg-white group-hover:opacity-30'
      },
      toned: {
        base: 'data-[disabled]:bg-black/10 data-[disabled]:text-black/25',
        overlay: ' group-hover:opacity-10'
      },
      outlined: {
        base: 'border border-solid bg-white text-black data-[disabled]:bg-black/25 data-[disabled]:text-black/25',
        overlay: ' group-hover:opacity-10'
      }
    },
    label: {
      true: 'rounded-md'
    },
    clickable: {
      true: 'cursor-pointer'
    },
    flat: {
      true: '!shadow-none'
    }
  },
  defaultVariants: {
    color: 'primary',
    size: 'md'
  },
  compoundVariants: [
    // Default Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'default',
          class: item.default
        }) as any
    ),
    // Toned Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'toned',
          class: item.toned
        }) as any
    ),
    // Outlined Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'outlined',
          class: item.outlined
        }) as any
    )
  ]
});
